module.exports = __webpack_public_path__ + "static/media/Trainer_green.a24efd7a.png";